import React from 'react'

import { Grid, Input, SimpleCollapse } from 'components'
import { SPACING } from 'utils'

export interface IPagamentoCollpase {
  control: any
  errors: any
}
const PagamentoCollpase: React.FC<IPagamentoCollpase> = ({
  control,
  errors
}) => {
  return (
    <SimpleCollapse title="DADOS DA FOLHA DE PAGAMENTO">
      <Grid
        gridCols="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing5} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Horas Trabalhadas"
          placeholder="Qtd"
          formValue="qtHeNormal"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Horas Extras"
          placeholder="Qtd"
          formValue="qtHeQtd"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Valor Horas Extras"
          placeholder="R$"
          formValue="vlHoraExtras"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Total Salário Base"
          placeholder="R$"
          formValue="vlSalBase"
          disabled
        />
        <Input
          control={control}
          errors={errors}
          label="Total Folha de Pagamento"
          placeholder="R$"
          formValue="vlFolhaPagto"
          disabled
        />
      </Grid>
    </SimpleCollapse>
  )
}

export default PagamentoCollpase
